import { EMarketingSpot } from '@/components/content/EMarketingSpot';
import { useHeaderPanels } from '@/components/content/Header/context/HeaderPanelsContext';
import {
	emarketingSpotMenuDrawerContentSX,
	emarketingSpotMenuDrawerSX,
	emarketingSpotMenuDrawerTitleSX,
} from '@/components/content/Header/styles/stickyMobileBottomHeader';
import { Box, SwipeableDrawer } from '@mui/material';
import { FC } from 'react';

interface EmarketingSpotMenuDrawerProps {
	menuDynamicTriggerEspot: string;
	menuDynamicsItemsEspot: string;
	menuDynamicTitleEspot: string;
}

export const EmarketingSpotMenuDrawer: FC<EmarketingSpotMenuDrawerProps> = ({
	menuDynamicTriggerEspot,
	menuDynamicsItemsEspot,
	menuDynamicTitleEspot,
}) => {
	const { activePanelId, togglePanel, openPanel, closePanel } = useHeaderPanels();
	const espotId = menuDynamicTriggerEspot;
	const isPanelOpen = activePanelId === espotId;

	return (
		<>
			<Box onClick={(e) => togglePanel(espotId, e?.currentTarget ?? null)}>
				<EMarketingSpot
					id={menuDynamicTriggerEspot}
					properties={{ emsName: menuDynamicTriggerEspot }}
				/>
			</Box>
			<SwipeableDrawer
				open={isPanelOpen}
				onClose={closePanel}
				onOpen={(e: React.MouseEvent<HTMLDivElement>) =>
					openPanel(espotId, e?.currentTarget ?? null)
				}
				elevation={4}
				anchor="bottom"
				sx={emarketingSpotMenuDrawerSX}
			>
				<Box>
					<Box sx={emarketingSpotMenuDrawerTitleSX}>
						<EMarketingSpot
							id={menuDynamicTitleEspot}
							properties={{ emsName: menuDynamicTitleEspot }}
						/>
					</Box>
					<Box sx={emarketingSpotMenuDrawerContentSX}>
						<EMarketingSpot
							id={menuDynamicsItemsEspot}
							properties={{ emsName: menuDynamicsItemsEspot }}
						/>
					</Box>
				</Box>
			</SwipeableDrawer>
		</>
	);
};
